import React from 'react';
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import {
  formatDateTime,
  formatHrs1,
  formatPct,
  truncate,
} from './historyFormatters';
import { tableSx, headSx, numSx, valueSx, tooltipPopperProps } from './historyTableStyles';

/** Type chip: field = blue accent, shop = amber. */
function TypeChip({ type }) {
  const isField = type === 'field';
  return (
    <Chip
      label={type}
      size="small"
      sx={{
        height: 22,
        fontSize: '0.72rem',
        fontWeight: 600,
        textTransform: 'capitalize',
        bgcolor: isField ? 'var(--phm-accent-bg)' : 'var(--phm-surface-strong)',
        color: isField ? 'var(--phm-accent-text)' : 'var(--phm-amber-text)',
        border: `1px solid ${
          isField ? 'var(--phm-accent-border)' : 'var(--phm-border)'
        }`,
      }}
    />
  );
}

/**
 * EarnedHistoryTable — Date & Time | Type | Previous % | New % | Earned hrs |
 * Changed by | Notes. Oldest first (from API). Null previous % shows an
 * em-dash; long notes truncate with a tooltip for the full text.
 */
function EarnedHistoryTable({ rows = [] }) {
  if (!rows.length) {
    return <div className="phm-empty">No records found.</div>;
  }

  return (
    <Table size="small" stickyHeader sx={tableSx}>
      <TableHead>
        <TableRow>
          <TableCell sx={headSx}>Date &amp; Time</TableCell>
          <TableCell sx={headSx}>Type</TableCell>
          <TableCell sx={{ ...headSx, ...numSx }}>Previous %</TableCell>
          <TableCell sx={{ ...headSx, ...numSx }}>New %</TableCell>
          <TableCell sx={{ ...headSx, ...numSx }}>Earned hrs</TableCell>
          <TableCell sx={headSx}>Changed by</TableCell>
          <TableCell sx={headSx}>Notes</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((r) => (
          <TableRow key={r.id}>
            <TableCell sx={valueSx}>{formatDateTime(r.changedAt)}</TableCell>
            <TableCell>
              <TypeChip type={r.pctType} />
            </TableCell>
            <TableCell sx={numSx}>{formatPct(r.oldPercentComplete)}</TableCell>
            <TableCell sx={numSx}>{formatPct(r.newPercentComplete)}</TableCell>
            <TableCell sx={numSx}>{formatHrs1(r.earnedHrs)}</TableCell>
            <TableCell sx={valueSx}>{r.changedByName || '—'}</TableCell>
            <TableCell sx={{ color: 'var(--phm-text-value)' }}>
              {r.notes ? (
                r.notes.length > 30 ? (
                  <Tooltip title={r.notes} PopperProps={tooltipPopperProps}>
                    <span>{truncate(r.notes)}</span>
                  </Tooltip>
                ) : (
                  r.notes
                )
              ) : (
                '—'
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default EarnedHistoryTable;
